import { CompanyInfo } from '@src/constants';
import s from './Terms.module.css';

const TermsComponent = () => {
  //TODO: toptoon
  return (
    <div className={s.termsWrap}>
      <h2>Terms of Service</h2>
      <h3>Introduction &amp; Acceptance of Terms of Service</h3>
      <p>
        By using the {CompanyInfo.HOST_NAME_CAMALCASE} website, mobile
        application, or any other Day Comics service provided to you by TOPCO
        INTERNATIONAL INC. (collectively the &quot;Services&quot;), you signify
        your agreement to (1) these terms and conditions (the &quot;Terms of
        Service&quot;) and (2) our Privacy Policy (found at&nbsp;
        <a style={{ color: '#5b96cf' }} href="/privacy">
          {`https://${CompanyInfo.HOST_NAME_DEFAULT}.com/privacy`}
        </a>
        ).
        <br />
        <br />
        Although we will attempt to notify you when major changes are made to
        these Terms of Service, you should periodically review the most up to
        date version (found at &nbsp;
        <a style={{ color: '#5b96cf' }} href="/terms">
          {`https://${CompanyInfo.HOST_NAME_DEFAULT}.com/terms`}
        </a>
        ). {CompanyInfo.HOST_NAME_CAMALCASE} may, in its sole discretion, modify
        or revise these Terms of Service at any time. Modifications and
        revisions will take effect immediately after they have been posted.
        Nothing in these Terms of Service shall be deemed to confer any third
        party rights.
      </p>

      <h3>User Accounts</h3>
      <p>
        When creating an account with an e-mail address, you must use your own
        valid e-mail address. When creating an account with a social account,
        you must use your own social account. If you use an invalid e-mail
        address to create an account, intentionally or unintentionally, you are
        responsible for not receiving important information such as website
        information, service use, and etc.
        <br />
        <br />
        You are responsible for maintaining the confidentiality of the password
        and username. You must not allow a third party to access your account.
        <br />
        <br />
        Although {CompanyInfo.HOST_NAME_CAMALCASE} will not be liable for your
        losses caused by any unauthorized use of your account, you may be liable
        for the losses of {CompanyInfo.HOST_NAME_CAMALCASE} due to such
        unauthorized use of your account.
        <br />
        <br />
        You must be at least fourteen (14) years and older to use the Service.
        You must affirm to us that you are either eighteen (18) years old or
        older, or an emancipated minor, or possess legal parental or guardian
        consent, and are fully able and competent to enter into the terms
        mentioned in our Terms. If you are under thirteen (13) years old, please
        do not use the Service.
        <br />
        <br />
        When creating or updating an account, you may be asked to provide us
        with certain personal information, which may include your e-mail address
        and other information that can be used to identify you. Such
        information, if provided to us, will be held and used in accordance with
        our Service.
      </p>

      <h3>Service</h3>
      <p>
        These Terms of Service apply to all users of{' '}
        {CompanyInfo.HOST_NAME_CAMALCASE} Services, including users who are also
        contributors of Content to the Service.
        <br />
        <br />
        &quot;Content&quot; includes the text, graphics, photos, videos,
        audiovisual combinations and other Content you may view on, access
        through, or contribute to the Service.
        <br />
        <br />
        The Service includes all aspects of any{' '}
        {CompanyInfo.HOST_NAME_CAMALCASE}, including but not limited to services
        offered via the {CompanyInfo.HOST_NAME_CAMALCASE} website, mobile app,
        or other applications.
        <br />
        <br />
        You understand that the Service is an evolving one. The Service may vary
        by device and medium, and functionalities and features may also differ
        between devices. The Company may require that you accept updates to the
        Service, the App or Site you have installed on or access via your device
        or computer. You acknowledge that the use of the Service may require
        third party software that is subject to third party licenses.
        <br />
        <br />
        Where Updates are automatically installed, you agree that such Updates
        may be automatically installed without providing any additional notice
        or receiving any additional consent.
        <br />
        <br />
        The Service may contain links to third party websites that are not owned
        or controlled by {CompanyInfo.HOST_NAME_CAMALCASE}.
        <br />
        {CompanyInfo.HOST_NAME_CAMALCASE} has no control over, and assumes no
        responsibility for, the content, privacy policies, or practices of any
        third party websites. In addition, {CompanyInfo.HOST_NAME_CAMALCASE}{' '}
        will not and cannot censor or edit the content of any third-party site.
        By using the Services you agree to these terms:
        <br />
        <br />
        {CompanyInfo.HOST_NAME_CAMALCASE} reserves the right to remove Content
        without prior notice.
        <br />
        <br />
        {CompanyInfo.HOST_NAME_CAMALCASE} reserves the right to discontinue any
        aspect of the Service at any time.
      </p>

      <h3>{CompanyInfo.HOST_NAME_CAMALCASE} Premium Membership</h3>
      <ol>
        <ul className={s.subUl}>
          <h4>Payment Terms</h4>
          <li>
            • Your premium membership is a subscription-based service which will
            continue and automatically renew until terminated or as otherwise
            stated during sign-up or other communications with you. You can
            cancel your Subscription before it renews.
          </li>
          <li>
            • The premium membership can be charged monthly, every three month,
            or every six month. By signing up for our premium membership, you
            agree {CompanyInfo.HOST_NAME_CAMALCASE} or its payment processor may
            charge the fees shown to you during sign up on a periodic basis to
            the payment method you specify at the time of your initial purchase.
          </li>
          <li>
            • By signing up for our premium membership, you agree that it will
            be automatically charged to you on the specific billing date, in
            some cases, your payment date may change, for example if your paid
            membership began on a day not contained in a particular month.
          </li>
          <li>
            • If a payment is not successfully settled, due to expiration,
            insufficient funds, or otherwise, and you do not cancel your
            account, we may suspend your access to the service until we have
            successfully charged a valid payment method.
          </li>
          <li>
            • For some payment methods, the issuer may charge you certain fees,
            such as foreign transaction fees or other fees relating to the
            processing of your payment method.
          </li>
        </ul>
        <ul className={s.subUl}>
          <h4>Termination</h4>
          <li>
            • You can cancel your membership at any time by contacting at our
            customer service at {CompanyInfo.EMAIL_CS}.
          </li>
          <li>
            • Your benefits will last until the end of the month and you will
            have continued access to your membership for the remainder of the
            period, but you will not receive a refund.
          </li>
          <li>
            • Your membership will continue on a recurring basis to its terms
            unless you cancel your membership or are otherwise suspended.
          </li>
          <li>
            • You must cancel your membership before your next renewal date in
            order to avoid billing for each renewal period.
          </li>
        </ul>
      </ol>

      <h3>Provision of Information &amp; Advertisement</h3>
      <p>
        We may post various information regarding the Service and advertisements
        on the Service, send e-mails, SMS(MMS), or Push Notification.
        <br />
        <br />
        Utilizing advertisements posted on the Service, and making transactions
        on the advertisement are matters between you and the advertiser. Any
        disputes or matters between you and the advertiser have to be solved
        between you and the advertiser, and we are not liable for any reason.
        <br />
        <br />
        In order to use our Service, you will need certain equipment and
        resources, such as Internet access, a mobile device or computer. It is
        your sole responsibility to procure the necessary equipment and
        resources to use our Service. You are responsible for all data charges
        you incur from using our Service.
      </p>

      <h3>Limitations</h3>
      <p>
        In a case when a user performs any of the following activities, the user
        may be restricted of use from {CompanyInfo.HOST_NAME_CAMALCASE} without
        any prior notice:
      </p>
      <ol>
        <li>1. Attempt to hack, or otherwise abuse any system.</li>
        <li>2. Falsification, crime tampering, theft, or act of fraudulent.</li>
        <li>
          3. Web crawling webcomics content using any appliance, collecting and
          distributing with abnormal procedure.
        </li>
        <li>
          4. Any act related to copyright infringement of webcomics content.
        </li>
        <li>5. Repetitive access to the site with irregular action.</li>
      </ol>

      <h3>Coin Purchase and Usage</h3>
      <p>
        Our service may include content which requires coin usage.
        <br />
        <br />
        Coins can be purchased or provided via promotions, can be only used on
        this website and does not hold actual value as a real currency.
        <br />
        <br />· The purchase method, payment type, the scale, and the maximum
        amount of coins that can be purchased may change within the
        company&apos;s discretion at any time, {
          CompanyInfo.HOST_NAME_CAMALCASE
        }{' '}
        is not responsible for the user or a third party if such rights are
        exercised.
        <br />
        <br />· Coins can only be purchased from {CompanyInfo.HOST_NAME_DEFAULT}
        .com or our authorized partners.
        <br />
        <br />
        · Coins can only be used in the account to which they were paid, and
        cannot be transferred or sold in any way to others including third
        parties.
        <br />
        <br />
        · Any coin purchases are final and non-refundable unless otherwise
        required by law. When required by relevant laws and regulations, Day
        Comics will accept refund requests.
        <br />
        <br />· {CompanyInfo.HOST_NAME_CAMALCASE} may provide bonus coins to
        users in various ways through promotions etc. Bonus coins may be subject
        to expiration, which period will be specified. When using coins to
        access any paid content, bonus coins with closer expiration dates will
        be used first.
      </p>

      <h3>Refund</h3>
      <div className={s.des}>
        The following payment types are non-refundable.
        <br />
        <br />
        <ul>
          <li>Canada: Neosurf</li>
          <li>Canada & US: CVS, Dollar General, Circle K</li>
          <li>Germany: Giropay</li>
          <li>
            Mexico: Safetypay, Oxxo, Efectivo, Bank Transfer Mexico, Cash
            Payments Mexico
          </li>
          <li>
            Philippines: Cash Payment Philippines, Shopee Pay Philippines E,
            Bank Transfer Philippines, GrabPay, 7-Eleven, Gcash, PayMaya
          </li>
          <li>Singapore: Singtel Dash, PayNow, eNets</li>
          <li>Hong Kong: FPS Hong Kong</li>
          <li>Australia: Poli, PayID</li>
          <li>Italy: Mybank</li>
          <li>Netherlands: iDeal</li>
          <li>Poland: Bank Transfer Poland, Bilk, Przelewy24</li>
          <li>Portugal: Payshop, Multibanco</li>
          <li>Brazil: PIX, Safetypay, MercadoPago</li>
          <li>Peru: Bank Transfer Peru</li>
          <li>
            Indonesia: ATM Transfer Indonesia, Sakuku, Minimart, Doku Wallet,
            JeniusPay, LinkAja, OVO, GudangVoucher, Indomaret
          </li>
          <li>
            Malaysia: Bank Transfer Malaysia, Boost Wallet, TNG Ewallet Online,
            mCash
          </li>
          <li>
            Thailand: Tesco Lotus, Reward Points, Bank Transfer Thailand, K
            Plus, Big C, CenPay, Boonterm Kiosk, ShopeePay Thailand, SCB Easy
            Application, Krungsri Mobile Application, Thai QR
          </li>
          <li>Nigeria: Paga</li>
          <li>Ghana: Mobile Money Ghana</li>
        </ul>
      </div>

      <h3>Third party fees</h3>
      <p>
        While using our service, users will be subject to the terms of use and
        privacy policy of the third-party payment. (Billings from mobile network
        providers). You are solely responsible for paying all such fees and
        complying with its applicable conditions.
      </p>

      <h3>Copyright</h3>
      <p>
        You may not reproduce, distribute, rent, lease, sell, license, copy,
        modify or otherwise use the information you have obtained through our
        Service for profit.
      </p>

      <h3>Indemnification</h3>
      <p>
        Other than as expressly set out in these terms or in additional terms,
        {CompanyInfo.HOST_NAME_CAMALCASE} will not make any specific promises
        about the Service.
        <br />
        <br />
        {CompanyInfo.HOST_NAME_CAMALCASE} makes no uptime guarantee whatsoever
        regarding our Service. Our Service is intended to be reliable, but is
        not intended to be reliable or available at all times. Our Service is
        subject to interruptions, and you agree that{' '}
        {CompanyInfo.HOST_NAME_CAMALCASE} will not be responsible or liable for
        any loss or damage whatsoever resulting from any failure or delay of our
        Service.
        <br />
        <br />
        Our Service may be temporarily suspended without notice to you.
        Suspension of our Service may result from a variety of reasons,
        including system failure, maintenance, or other circumstances. You agree
        that you will not be entitled to any refund or compensation for such
        suspensions.
        <br />
        <br />
        We are not liable for any claim or dispute between you and another user,
        or a third party that arises in whole or in part from the Service.
        <br />
        <br />
        We are not liable for reliability or accuracy of any information, data,
        or facts posted on our Service, except when it was caused by gross
        negligence or intentionally done.
      </p>

      <h3>DISCLAIMER</h3>
      <p>
        Please note that this site contains sexually oriented material intended
        for individuals 18 years of age or older and of legal age to view
        sexually explicit material as determined by the local and national laws
        of the region in which they reside. If such material offends you, of if
        you are accessing this website from a country or area where adult
        material is specifically prohibited by law, please do not access this
        website.
      </p>

      <h3>Contact</h3>
      <p>
        For questions about these Terms of Service, send an e-mail to&nbsp;
        <a href={`mailto:${CompanyInfo.EMAIL_CS}`} style={{ color: '#5b96cf' }}>
          {CompanyInfo.EMAIL_CS}
        </a>
      </p>
    </div>
  );
};

export default TermsComponent;
